import { render, staticRenderFns } from "./StampList.vue?vue&type=template&id=99c8023c&scoped=true&"
import script from "./StampList.vue?vue&type=script&lang=ts&"
export * from "./StampList.vue?vue&type=script&lang=ts&"
import style0 from "./StampList.vue?vue&type=style&index=0&id=99c8023c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c8023c",
  null
  
)

export default component.exports